import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryModalService {

  private selectedCountrySubject = new BehaviorSubject<any>(null);
  public selectedCountry$ = this.selectedCountrySubject.asObservable();

  constructor() { }

  setSelectedCountry(country: any): void {
    this.selectedCountrySubject.next(country);
  }

  getSelectedCountry(): any | null {
    return this.selectedCountrySubject.value;
  }

  clearSelectedCountry(): void {
    this.selectedCountrySubject.next(null);
  }
}
